// extracted by mini-css-extract-plugin
export default {"prompt":"login_prompt__0Kf3B"};